<template>
  <div class="main">
    <!-- Top Banner section -->
    <section class="hero is-pepi section">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title">
            Tutorials
          </h1>
          <hr />
        </div>
      </div>
    </section>
          
    <div v-if="loading" class="mask">
      <div class="loader"></div>
    </div>
    <div v-else class="wrapper">    
      <div class="columns">
        <div class="column">
          <section class="section-list-checkbox">
            <div class="section-toggle-checkbox">
              <div class="dropdown is-active">
                <div class="dropdown-trigger">
                  <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
                    <span>Categories</span>
                    <!-- <span class="icon is-small">
                      <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </span> -->
                  </button>
                </div>
                <div class="dropdown-menu" id="dropdown-menu" role="menu">
                  <div class="dropdown-content">
                    <!-- <label class="checkbox">
                      <input type="checkbox" value="all" v-on:change="clearTags()" checked>
                      All
                    </label> -->
                    <label class="checkbox" v-for="(value, label) in filters" :key="label">
                      <input type="checkbox" :id="value" :value="value" v-model="tags" v-on:change="updateTag()">
                      {{label}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <!-- Segment list section -->
        <div class="column is-three-quarters">
          <section class="section_list">
            <div class="search_wrapper">
              <div class="searchbox">
                <div class="field">
                  <div class="control">
                    <div class="content-filter-query-input-container">
                      <img src="../assets/img/search-light.svg" class="bannersearchicon">
                      <input type="text" name="q" id="q" placeholder="Search our content" autocomplete="off" spellcheck="false" class="input" v-model="search.query" v-debounce:240ms="getSegments">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h1 class="title" id="tutorial-content">
              Popular content
            </h1>
            <div v-if="elements.segments.length > 0">
              <div class="segment-wrapper" v-for="(segment, skey) in elements.segments" :key="skey">
              <div class="segment-header-tags">
                <div class="segment-btn-tags">
                  <a v-for="(tag, tkey) in segment.tags" :key="tkey" :href="'/tutorials/tag/'+tag">{{tag}}</a>
                </div>
                <span>5 min read</span>
              </div>
              <div v-if="segment.data.title">
                <div class="segment_title" v-for="(data, dkey) in segment.data.title" :key="dkey">
                  <h3 class="title">
                    <div class="segment_slug">
                      <a :href="'/tutorials/'+encodeURIComponent(segment.uid)+'/'"> {{data.text}} </a>
                    </div>
                  </h3>
                </div>
              </div>
              <div class="segment_description" v-if="segment.data.description">
                  <p class="description">{{$prismic.richTextAsPlain(segment.data.description) | truncate(220, '...')}}</p>
              </div>
              <div class="details" v-if="segment.data.author.data">
                <span class="author">
                  <span>
                    <img :src="segment.data.author.data.author_image.url" />
                    <a :href="'/tutorials/author/'+segment.data.author.uid+'/'">{{segment.data.author.data.first_name}} {{segment.data.author.data.last_name}}</a>
                  </span>
                </span>
                <a :href="'/tutorials/'+encodeURIComponent(segment.uid)+'/'">Read more</a>
              </div>
            </div>
            </div>
            <div v-else>
              <h2>No match found</h2>
            </div>
          </section>
        </div>
      </div>

      <!-- Load button -->
      <div id="control-button-wrapper"> 
        <nav class="pagination is-centered" role="navigation" aria-label="pagination">
          <ul class="pagination-list">
            <li>
              <a class="pagination-previous first-pagination" @click="getPage(index)">
                <i class="fa fa-angle-double-left" aria-hidden="true"></i>
              </a>
            </li>
            <!-- For later -->
            <!-- <li>
              <a class="pagination-previous">
                <i class="fa fa-angle-left" aria-hidden="true"></i>
              </a>
            </li> -->

            <li v-for="index in (parseInt(paginate.pages))" :key="index">
              <a class="pagination-link" :class="{'is-current': (active_page===index)}" @click="getPage(index)">{{index}}</a>
            </li>
            <!-- For later -->
            <!-- <li>
              <a class="pagination-next">
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </a>
            </li> -->
            <li>
              <a class="pagination-next last-pagination" @click="getPage(parseInt(paginate.pages))">
                <i class="fa fa-angle-double-right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <MarketingDemoSection></MarketingDemoSection>
      <NetcoreBlogSection></NetcoreBlogSection>
    </div>
  </div>
</template>

<script>
import NetcoreBlogSection from '../components/NetcoreBlogSection';
import MarketingDemoSection from '../components/MarketingDemoSection.vue';
export default {
  name: 'ListSearch',
  data () {
    return {
      elements: {
        segments: []
      },
      search:{
        query : ''
      },
      paginate:{
        pgnum : 1,
        pgsize : 8,
        pages : 10 
      },
      loading: true,
      filters: {
        "Email blacklist": "email-blacklist",
        "Email delivery": "email-delivery",
        "Email spam": "email-spam",
        "Bimi": "bimi",
        "Email authentication": "email-authentication"
      },
      tags: [],
      loading: true,
      active_page: 1
    }
  },
  components: {
    NetcoreBlogSection,
    MarketingDemoSection
  },
  methods: {
    getSegments(){
      this.loading = true;
      this.paginate.pgnum = 1;
      this.$prismic.client.query([
        this.$prismic.Predicates.at('document.type', 'post'),
        this.$prismic.Predicates.fulltext('document', this.search.query),
        this.$prismic.Predicates.at('document.tags', this.tags)
        ],
        { orderings : '[my.post.published desc]', pageSize : this.paginate.pgsize, page : this.paginate.pgnum, fetchLinks: 'author.first_name, author.last_name, author.author_image',}
      ).then((response) => {
        // console.log(response);
        if (response.total_results_size === 0) {
          this.elements.segments = [];
          this.paginate.pages = 0;
        } else {
          this.paginate.pages = Math.ceil(response.total_results_size / this.paginate.pgsize);
          this.elements.segments = response.results;
        }
        // this.paginate.pages = response.total_results_size;
        this.loading = false;
        this.$nextTick(() => {
          document.dispatchEvent(new Event('render-completed'));
        });
      })
    },
    getPage(index){
      this.loading = true;
      this.active_page = 1;
      this.$prismic.client.query([
        this.$prismic.Predicates.at('document.type', 'post'),
        this.$prismic.Predicates.fulltext('document', this.search.query),
        this.$prismic.Predicates.at('document.tags', this.tags)
        ],
        { orderings : '[my.post.published desc]', pageSize : this.paginate.pgsize, page : index, fetchLinks: 'author.first_name, author.last_name, author.author_image',}
      ).then((response) => {
        // console.log(response);
        if (response.total_results_size === 0) {
          this.elements.segments = [];
          this.paginate.pages = 0;
        } else {
          this.paginate.pages = Math.ceil(response.total_results_size / this.paginate.pgsize);
          this.elements.segments = response.results;
        }
        this.loading = false;
        this.active_page = index;
        const scrollDiv = document.getElementById("tutorial-content");
        window.scrollTo({ top: scrollDiv});
      });
    },
    updateTag(){
      this.active_page = 1;
      this.getSegments();
    },
    clearTags(){
      this.active_page = 1;
      this.tags = [];
    },
  },
  created () {
    this.getSegments();
  },
  metaInfo () {
    return {
      meta: [
        {name: 'description', content: 'Tutorials'},
      ],
      link: [
        {rel: 'canonical', href: 'https://pepipost.com/tutorials/'}
      ]
    }
  }  
}
</script>
